<ng-container *ngIf="serials?.length; else none">
  <div class="serial-summary" *ngIf="summary; else tags" (click)="$event.stopPropagation()">
    <span>{{ (serials.length === 1 ? 'serials.countOne' : 'serials.count') | translate: { count: serials.length } }}</span>
    <a href="#" class="serial-link" *ngIf="prdID" (click)="openReport($event)">{{ 'serials.openReport' | translate }}</a>
  </div>
  <ng-template #tags>
    <div class="serial-tags" role="list" (click)="$event.stopPropagation()">
      <span class="serial-tag" role="listitem" *ngFor="let s of serials | slice:0:maxTags">{{ s }}</span>
      <button type="button" class="serial-tag serial-tag-more" *ngIf="serials.length > maxTags"
              [attr.aria-expanded]="open" (click)="open = !open; $event.stopPropagation()">
        {{ open ? ('serials.showFewer' | translate) : ('serials.more' | translate: { count: serials.length - maxTags }) }}
      </button>
    </div>
    <div class="serial-all" *ngIf="open" (click)="$event.stopPropagation()">
      <div class="serial-all-head">
        <span>{{ 'serials.count' | translate: { count: serials.length } }}</span>
        <button type="button" class="serial-link" (click)="copyAll()">
          {{ (copied ? 'serials.copied' : 'serials.copyAll') | translate }}
        </button>
      </div>
      <div class="serial-all-list" role="list" tabindex="0">
        <span role="listitem" *ngFor="let s of serials">{{ s }}</span>
      </div>
      <div class="serial-all-foot" *ngIf="prdID">
        <a href="#" class="serial-link" (click)="openReport($event)">{{ 'serials.openReport' | translate }}</a>
      </div>
    </div>
  </ng-template>
</ng-container>
<ng-template #none>
  <p class="serial-none" *ngIf="serialized">
    <mat-icon>info_outline</mat-icon>
    <span>{{ (kind === 'receive' ? 'serials.notRecordedReceive' : 'serials.notRecordedPick') | translate }}</span>
  </p>
</ng-template>
